// Show labels ("Premiere", "Preview") shown to customers next to the show time (JDEV-3118).

export const SHOW_LABEL_DEFAULT_COLOR = '#6c757d'

// Offered in the label dialog; any #rrggbb value is accepted.
export const SHOW_LABEL_COLORS = ['#c0392b', '#d35400', '#f39c12', '#27ae60', '#16a085', '#2a7ab0', '#8e44ad', '#2c3e50', '#6c757d']

// Dark text on light backgrounds, white otherwise
export function showLabelTextColor (color) {
  const hex = /^#[0-9a-f]{6}$/i.test(color || '') ? color.slice(1) : SHOW_LABEL_DEFAULT_COLOR.slice(1)
  const r = parseInt(hex.slice(0, 2), 16)
  const g = parseInt(hex.slice(2, 4), 16)
  const b = parseInt(hex.slice(4, 6), 16)
  return (r * 299 + g * 587 + b * 114) / 1000 > 160 ? '#222222' : '#ffffff'
}

export function showLabelStyle (label) {
  const color = label && label.color ? label.color : SHOW_LABEL_DEFAULT_COLOR
  return { backgroundColor: color, color: showLabelTextColor(color) }
}
